import { render } from "./_id.vue?vue&type=template&id=2de30f60&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=2de30f60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de30f60"]])

export default __exports__